module.exports = __webpack_public_path__ + "static/media/pacientTopImg.321a53bb.png";